import { render, staticRenderFns } from "./ElectricalHeaterDescription.vue?vue&type=template&id=fb2273ea&scoped=true"
import script from "./ElectricalHeaterDescription.vue?vue&type=script&lang=ts"
export * from "./ElectricalHeaterDescription.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalHeaterDescription.vue?vue&type=style&index=0&id=fb2273ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2273ea",
  null
  
)

export default component.exports